import { ExportsApiBase } from './paymentApi';

class ExportApi extends ExportsApiBase {
}

export default new ExportApi();
